import type { QueryClient } from "@tanstack/react-query";
import { pickNearbyBookableCities } from "../lib/nearby-bookable-cities";
import { emptyHubCitiesQueryOptions, nearbyRailQueryOptions } from "./activities-query";

export interface EmptyHubRailInput {
  citySlug: string;
  lang: string;
  /** City + category hub: the city itself may still have other things to book. */
  includeSelf: boolean;
}

/**
 * Warm everything `EmptyCityHelp` reads, so the "book nearby" cards are in the
 * server-rendered HTML rather than arriving after hydration. Called by the hub
 * loaders only when the hub's own list came back empty. Never throws: both
 * query functions already resolve to empty lists on failure.
 */
export async function prefetchEmptyHubRail(
  queryClient: QueryClient,
  { citySlug, lang, includeSelf }: EmptyHubRailInput,
): Promise<void> {
  const cities = await queryClient.ensureQueryData(emptyHubCitiesQueryOptions(lang));
  const { cities: sources } = pickNearbyBookableCities(cities, citySlug, { includeSelf });
  await Promise.all(
    sources.map((city) => queryClient.ensureQueryData(nearbyRailQueryOptions(city.slug, lang))),
  );
}
